import { NavigationItem } from '../types';

export const navigationItems: NavigationItem[] = [
  {
    id: 'home',
    label: 'Home',
    href: '/'
  },
  {
    id: 'about',
    label: 'About',
    href: '/about'
  },
  {
    id: 'editions',
    label: 'Editions',
    href: '/editions'
  },
  {
    id: 'events',
    label: 'Events',
    href: '/events'
  },
  {
    id: 'registration',
    label: 'Registration',
    href: '/registration'
  },
  {
    id: 'media',
    label: 'Media',
    href: '/media'
  },
  {
    id: 'contact',
    label: 'Contact',
    href: '/contact'
  }
];
